// Landing-page test IDs (Utsah Green Gift Initiative)
export const LANDING = {
  // Nav
  navLogo: "nav-logo",
  navBookMeeting: "nav-book-meeting",
  // Hero
  heroStartPlanting: "hero-start-planting-cta",
  // How it works
  howStep: (i) => `how-step-${i}`,
  // Projects
  projectCard: (i) => `project-card-${i}`,
  projectViewLink: (i) => `project-view-link-${i}`,
  // Certificate section — nothing interactive
  // FAQ
  faqItem: (i) => `faq-item-${i}`,
  faqToggle: (i) => `faq-toggle-${i}`,
  // CTA section
  ctaExploreCollections: "cta-explore-collections",
  ctaWhatsapp: "cta-whatsapp",
  // Lead dialog (shared between Book-a-Meeting and Bulk Order)
  leadDialog: "lead-dialog",
  leadDialogTitle: "lead-dialog-title",
  leadName: "lead-input-name",
  leadEmail: "lead-input-email",
  leadCompany: "lead-input-company",
  leadPhone: "lead-input-phone",
  leadQuantity: "lead-input-quantity",
  leadMessage: "lead-input-message",
  leadSubmit: "lead-submit-button",
  leadDialogClose: "lead-dialog-close",
  // Bulk trigger (footer link)
  footerBulkTrigger: "footer-bulk-trigger",
  footerContactTrigger: "footer-contact-trigger",
  // Whatsapp sticky
  whatsappSticky: "whatsapp-sticky",
};
